import { createStore } from 'satcheljs';
import { getGuid } from 'owa-guid';
import TranslationStore from './schema/TranslationStore';

export default createStore<TranslationStore>('TranslationStore', {
    sessionId: getGuid(),
    localeOfSupportedLanguageMap: null,
    supportedLanguageMap: null,
    isUserLocaleSupported: false,
    userLanguageName: null,
    userLanguageTag: null,
    settings: {
        translationMode: null,
        targetLanguage: null,
        excludedLanguages: [],
        initialized: false,
    },
})();
